export let urlEndpoints: string = 'https://repoblando-dot-repoblando.nw.r.appspot.com';
//https://repoblando-dot-repoblando.nw.r.appspot.com
//http://192.168.197.97:8080
//http://localhost:8080